module.exports = __webpack_public_path__ + "img/experience2.5206c648.png";